<div class="grid-container">
  <!--INICIA CONTENIDO PRINCIPAL-->
  <mat-card class="dashboard-card" appearance="outline" style="margin-bottom: 16px;">
    <mat-card-header>
      <mat-card-title>Explora MiGLM</mat-card-title>
      <mat-card-subtitle *ngIf="hijos" class="subtitle">Aquí podrá encontrar todas las aplicaciones disponibles en
        MiGLM, diseñadas para
        apoyar su experiencia y la de su familia.</mat-card-subtitle>
      <mat-card-subtitle *ngIf="!hijos && materias" class="subtitle">Descubre herramientas y recursos pensados para
        potenciar tu
        experiencia en MiGLM. Aquí encontrarás accesos directos y soluciones que acompañan tu día a
        día.</mat-card-subtitle>
    </mat-card-header>
    <app-plataformas></app-plataformas>
  </mat-card>

  <div class="card-grid">
    <!-- Inicio mis hijos -->
    <div *ngIf="hijos" [style]="hijos ? '' : 'display: none'">
      <ng-container *ngIf="loggedUser | async as user; else loading">
        <mat-card class="dashboard-card" appearance="outline">
          <mat-card-header>
            <mat-card-title i18n="@@misHijos" style="margin-bottom: 8px;">Mis hijos</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="hijos-container">
              <ng-container *ngFor="let hijo of hijos; let i = index">
                <mat-card class="hijo-card mat-elevation-z2" (click)="openMenu($event, menuTriggers.get(i))">
                  <div class="card-content">
                    <!-- Sección izquierda: Foto y datos -->
                    <div class="hijo-info">
                      <img mat-card-avatar [src]="hijo.imageUrl" appImageError class="hijo-image"
                        matTooltip="Foto de perfil">
                      <div class="hijo-datos">
                        <h3 class="hijo-nombre">{{hijo.nombresApellidos}}</h3>
                        <span class="hijo-email" *ngIf="hijo.email">{{hijo.email}}</span>
                      </div>
                    </div>

                    <!-- Menú de opciones -->
                    <div class="hijo-acciones">
                      <button mat-icon-button [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger"
                        aria-label="Opciones" class="menu-button">
                        <mat-icon>more_vert</mat-icon>
                      </button>

                      <mat-menu #menu="matMenu">
                        <ng-container *ngFor="let link of hijo.links">
                          <button mat-menu-item (click)="navigate(link); $event.stopPropagation()">
                            <mat-icon>{{link.urlIcon}}</mat-icon>
                            <span>{{ link.nombre }}</span>
                          </button>
                        </ng-container>
                      </mat-menu>
                    </div>
                  </div>

                  <!-- Mensaje pendiente -->
                  <div *ngIf="hijo.isPendiente" class="pendiente-mensaje">
                    <p>Contacte a cartera&#64;glm.edu.co extensión 231</p>
                  </div>
                </mat-card>
              </ng-container>
            </div>
          </mat-card-content>
        </mat-card>
      </ng-container>
    </div>
    <!--INICIA FRANJA ALUMNO-PROFE Usuario inicial-->

    <div *ngIf="materias || hijos" #columnsContainer [style]="materias.length == 0 && hijos ? 'display: none' : ''">
      <div *ngIf="!loadingData; else loading">
        <div *ngIf="materias && !hijos">
          <app-glm-reconocimiento-card></app-glm-reconocimiento-card>
        </div>
        <div *ngIf="materias">
          <app-glm-materias-card [propio]="true" [materias]="materias" [hijo]="alumno"
            (detalleOpen)="setOverlay($event)"></app-glm-materias-card>
        </div>
      </div>
    </div>
    <!-- //Espacio para el overlay -->
    <div *ngIf="notificaciones && notificaciones.length > 0 && !hijos && !materias"></div>
    <!-- INICIA LA COLUMNA CON CALENDARIO -->
    <div class="home-aux">
      <div>
        <ng-container *ngIf="notificaciones && notificaciones.length > 0">
          <mat-card class="dashboard-card" appearance="outline">
            <mat-card-header>
              <mat-card-title i18n="@@notificaciones">Notificaciones</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <notificaciones [notifications]="notificaciones"></notificaciones>
            </mat-card-content>
          </mat-card>
        </ng-container>
        <!-- <ng-container *ngIf="loggedUser | async as user; else loading">
          <div>
            <h3 class="mat-h3" i18n="@@calendarioLabel">
              {{user.calendar == 'planeacion' ? 'Calendario de planeación' : 'Calendario escolar'}}</h3>
            <p></p>
            <ng-container *ngIf="user.calendar == 'planeacion'">
              <iframe scrolling="no" height="300" frameborder="0"
                src="https://www.google.com/calendar/embed?showTitle=0&amp;mode=AGENDA&amp;height=240&amp;wkst=1&amp;bgcolor=%23FFFFFF&amp;src=glm.edu.co_cl4smhj6lebg8ng3olb5pmurgc%40group.calendar.google.com&ctz=America/Bogota"></iframe>
            </ng-container>
            <ng-container *ngIf="user.calendar == 'escolar'">
              <iframe scrolling="no" height="300" frameborder="0"
                src="https://www.google.com/calendar/embed?showTitle=0&amp;mode=AGENDA&amp;height=240&amp;wkst=1&amp;bgcolor=%23FFFFFF&amp;src=calendario%40glm.edu.co&amp;color=%23125A12&amp;ctz=America%2FBogota"></iframe>
            </ng-container>
          </div>
        </ng-container> -->

      </div>
    </div>
    <!-- FIN COLUMNA CALENDARIO-->
  </div>
</div>

<!--Miscelaneos carga-->
<ng-template #loading>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>
<div *ngIf="overlay" class="custom-overlay" [style.height]="overlayHeight"
  style="position: fixed; top: 0; left: 0;width: 100%;height: 100%;">
</div>